import React, { useEffect, useState } from "react";
import { Row, Col, Table } from "react-bootstrap";
import PaypalAccountList from "./PaypalAccountList";
import PaypalAccountForm from "./PaypalAccountForm";
import Utils from "../../configs/Utils";

const PaypalAccountsBlock = ({ onAccountsChange }) => {
  const [accountList, setAccountList] = useState([]);
  const [updatingAccount, setUpdatingAccount] = useState({});
  const [accountDetail, setAccountDetail] = useState({});

  useEffect(() => {
    if (typeof onAccountsChange === "function") {
      onAccountsChange(accountList);
    }
  }, [accountList, onAccountsChange]);

  useEffect(() => {
    const detail = {};
    if (updatingAccount?.account) detail["Account"] = updatingAccount.account;
    if (updatingAccount?.accountName) detail["Tên tài khoản"] = updatingAccount.accountName;
    if (updatingAccount?.meta?.mode) detail["Mode"] = updatingAccount.meta.mode;
    if (updatingAccount?.meta?.email) detail["Email"] = updatingAccount.meta.email;
    if (updatingAccount?.meta?.payer_id) detail["Payer ID"] = updatingAccount.meta.payer_id;
    if (updatingAccount?.status) detail["Trạng thái"] = updatingAccount.status;
    if (updatingAccount?.updatedAt) detail["Cập nhật"] = Utils.dateFormat(updatingAccount.updatedAt);
    setAccountDetail(detail);
  }, [updatingAccount]);

  return (
    <>
      <Row>
        <Col md={12}>
          <div className="my-3 p-3 bg-body rounded shadow-sm feature-box">
            <h6 className="heading border-bottom pb-2 mb-0">Tài khoản PayPal</h6>
            <PaypalAccountList
              accountList={accountList}
              setAccountList={setAccountList}
              updatingAccount={updatingAccount}
              setUpdatingAccount={setUpdatingAccount}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={5}>
          <PaypalAccountForm
            setAccountList={setAccountList}
            updatingAccount={updatingAccount}
            setUpdatingAccount={setUpdatingAccount}
          />
        </Col>
        <Col md={7}>
          <div className="my-3 p-3 bg-body rounded shadow-sm feature-box">
            <h6 className="heading border-bottom pb-2 mb-0">Chi tiết PayPal</h6>
            <Table striped size="sm" borderless>
              <tbody>
                {Object.keys(accountDetail).length === 0 ? (
                  <tr>
                    <td className="text-muted">Chọn một tài khoản để xem chi tiết...</td>
                  </tr>
                ) : (
                  Object.keys(accountDetail).map((key) => (
                    <tr key={key}>
                      <th className="text-end pe-4" style={{ width: 160 }}>{key}</th>
                      <td>{accountDetail[key]}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PaypalAccountsBlock;
